import template from './user-provider-details.html';
import userProviderDetailsController from './user-provider-details.controller';
import './user-provider-details.styl';

let userProviderDetailsComponent = {
  restrict: 'E',
  bindings: {
    user: '<'
  },
  template,
  controller: userProviderDetailsController,
  controllerAs: 'vm'
};

export default userProviderDetailsComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-provider-details/user-provider-details.component.js
 **/